//src\Pages\Home\TrendFashion\sections\BannerTriptychFashionSection.tsx
import React from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import type { StoreSection } from "../../../../redux/services/store/storePagesApi";

type Props = {
  section: StoreSection;
};

const BannerTriptychFashionSection: React.FC<Props> = ({ section }) => {
  const center = (section.settings_json?.center || {}) as any;
  const styles = (section.settings_json?.styles || {}) as any;

  const items = section.items || [];
  const left = items.find((i) => i.slot === "left")?.content_json || {};
  const right = items.find((i) => i.slot === "right")?.content_json || {};

  return (
    <section className={styles.section_class || "trend-fashion-home"}>
      <div className={styles.container_class || "container-fluid container-custom"}>
        <Row className="g-0">
          <Col lg={4}>
            <Card
              className="home-widgets card-height-100 border-0 rounded-end-0"
              style={{
                backgroundImage: left.image_url ? `url(${left.image_url})` : undefined,
                backgroundSize: left.background_size || "cover",
              }}
            >
              <Card.Body></Card.Body>
            </Card>
          </Col>

          <Col lg={4}>
            <Card className={`card-height-100 border-0 rounded-0 ${styles.center_bg_class || "bg-info-subtle"}`}>
              <Card.Body className="px-4 px-lg-5 text-center d-flex align-items-center">
                <div>
                  <h3
                    className="text-capitalize lh-base mb-2"
                    dangerouslySetInnerHTML={{ __html: center.heading_html || "" }}
                  />
                  {center.description ? <p className="fs-16 mb-4">{center.description}</p> : null}

                  <Button
                    variant={center.button_variant || "info"}
                    type="button"
                    className={styles.button_class || "btn-hover rounded-0"}
                    onClick={() => {
                      if (center.button_link) window.location.href = center.button_link;
                    }}
                  >
                    {center.button_text || "Shop Now"}{" "}
                    {center.button_icon ? <i className={`${center.button_icon} align-baseline ms-1`}></i> : null}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4}>
            <Card
              className="home-widgets card-height-100 border-0 rounded-start-0"
              style={{
                backgroundImage: right.image_url ? `url(${right.image_url})` : undefined,
                backgroundSize: right.background_size || "cover",
              }}
            >
              <Card.Body></Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default BannerTriptychFashionSection;